import { render } from "./gaozhishu.vue?vue&type=template&id=712620f1&scoped=true"
import script from "./gaozhishu.vue?vue&type=script&lang=js"
export * from "./gaozhishu.vue?vue&type=script&lang=js"

import "./gaozhishu.vue?vue&type=style&index=0&id=712620f1&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712620f1"]])

export default __exports__